import { gql } from 'apollo-boost';

export const PATCH_AGREEMENT = gql`
mutation patchAgreement($input: PatchAgreementInput!) {
    Result:patchAgreement(input: $input) {
      id
    }
  }
`;